/*
    Copyright (C) Paul B. Lucas 2025, 2026  ALL RIGHTS RESERVED
    Licensed to the University of Illinois Urbana Champaign

    This is a Javascript composable that fetches the next available number in a named set for use
    as a unique index.

    Parameters are set-name:  name of the set to use
    Returns are next available number

    The fetch is an async function that awaits a results of an axios call to the API which generates the 
    query array.  When promise is resolved, the results are returned in nextNumber ref.

    API configuration data is stored as JSON file in src/configuration/ and imported as a JSON array.  Import
    can do this from a basic JSON file.  Parameters in the config array include the base-url, the POSTQL ccf
    endpoint, and authentication data for the axios headers (API key).  Details:

        {
            "apim-key-name":    "Bearer",
            "apim-key":         "--- some key ---",
            "base-url":         "https://api.elam.fs.illinois.edu",
            "ccfURL":           "https://api.elam.fs.illinois.edu/ccf",
            "agreement-path":   "/agreements",
            "employee-path":    "/employees",
            "table-path":       "/tables",
            "assets-path":      "/assets",
            "image-url":        "/https://images.elam.fs.illinois.edu/employees/"     
        }     
        
    If the API URL changes in DNS, this file must be modified.

    USAGE:
        In calling code use the following:
        fetchNextNumber(aQuery).then(() -> {
            let number = newNumber.value
        })


    <Revision History>
        02/25/2025      pblucas     created 
        02/27/2025      pblucas     segregated out databases for NANs
        03/16/2026      pblucas     Corrected typos & updated copyright   

    </Revision History>
*/

import { ref }      from 'vue'
import axios        from 'axios'
import amApiConfigs from '@/configuration/amAPI.config.json'


const useNextAvailableNumberAPI = () =>    {

    // DO NOT USE DEFAULT FOR AUTH IF AXIOS IS ACCESSING MORE THAN ONE API
 
    const baseURL  = amApiConfigs['base-url']
    // set specific endpoint for employees
    let URINanPath =  amApiConfigs['nans-path']+'/'
    
    // value returned
    const nextNumber     =   ref('') 
    
    const  fetchNextNumber =  async (aQuery)  =>  {

        // convert array of key:value pairs to / delimited components for  URL
        // e.g.,  ["first-name: "john", "last-name":"Doe"]  =>  /first-name/John/last-name/Doe
        let uri = Object.keys(aQuery).map((k) => {
        return encodeURIComponent(k) + '/' + encodeURIComponent(aQuery[k])
        }).join('/')
        
        let url =  baseURL + URINanPath + uri    
        await axios({
            method:         'get',
            url:            url,
            headers:        {Authorization: `${amApiConfigs['apim-key-name']} ${amApiConfigs['apim-key']}`}
        })
        .then ( (response) => {
            if((response.data.response['status'] == "failed") || (response.data.response['http_return'] != 200)) { 
                console.log("FetchNextNumber:: error thrown in response")
                throw Error ("Unable to fetch next number")
            }
            nextNumber.value    = response.data.results['next-available-number']    
        })
        .catch( error =>  {
            console.log("FetchNextNumber:: "+ error.message)
        })
  }   // end function

  return {nextNumber, fetchNextNumber}
}

export default useNextAvailableNumberAPI